import { render, staticRenderFns } from "./Counter.global.vue?vue&type=template&id=5e2f22fd&scoped=true&lang=pug&"
import script from "./Counter.global.vue?vue&type=script&lang=ts&"
export * from "./Counter.global.vue?vue&type=script&lang=ts&"
import style0 from "./Counter.global.vue?vue&type=style&index=0&id=5e2f22fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f22fd",
  null
  
)

export default component.exports